/**
 * 日志工具
 * 根据环境变量控制日志输出，生产环境自动禁用 console 日志
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const enableConsoleLog = process.env.VUE_APP_ENABLE_CONSOLE_LOG === 'true' || isDevelopment;

// 创建日志对象
const logger = {
    log: (...args) => {
        if (enableConsoleLog) {
            console.log(...args);
        }
    },
    
    info: (...args) => {
        if (enableConsoleLog) {
            console.info(...args);
        }
    },
    
    warn: (...args) => {
        if (enableConsoleLog) {
            console.warn(...args);
        }
    },
    
    error: (...args) => {
        // 错误日志始终输出，但生产环境可以简化
        if (isDevelopment) {
            console.error(...args);
        } else {
            // 生产环境只输出关键错误信息
            const errorInfo = args.map(arg => {
                if (arg instanceof Error) {
                    return {
                        message: arg.message,
                        stack: arg.stack
                    };
                }
                return arg;
            });
            console.error(...errorInfo);
        }
    },
    
    debug: (...args) => {
        // debug 日志只在开发环境输出
        if (isDevelopment) {
            console.debug(...args);
        }
    },
    
    table: (...args) => {
        if (enableConsoleLog) {
            console.table(...args);
        }
    },
    
    group: (...args) => {
        if (enableConsoleLog) {
            console.group(...args);
        }
    },
    
    groupEnd: () => {
        if (enableConsoleLog) {
            console.groupEnd();
        }
    }
};

export default logger;

